import { coreCustomersByIdUsersGetSlice } from './get';
import { PaginatedResource } from '@sonar-software/sonar-ts-types';
import { updateCustomerUsersSyncSlice } from './update';
import { UserWithMetadata } from '@types';
import { AsyncState, combineAllWatchers, joinCollectionReducers } from '@sonar-software/xuder';
import { combineReducers, Reducer } from 'redux';

export const coreCustomersByIdUsersReducers = combineReducers({
	get: joinCollectionReducers(
		[ coreCustomersByIdUsersGetSlice.asyncReducers, updateCustomerUsersSyncSlice.syncReducer ],
		coreCustomersByIdUsersGetSlice.asyncState
	) as Reducer<AsyncState<PaginatedResource<UserWithMetadata>>>
});

export const coreCustomersByIdUsersWatchers = combineAllWatchers([ coreCustomersByIdUsersGetSlice.asyncWatchers ]);
